/**
 * @desc 驳回信息提交
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.ExportDeclarationYFXRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/exportDeclaration/bhExportDeclaration`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
